import { render } from "./base-tabview.vue?vue&type=template&id=be59c1f2&ts=true"
import script from "./base-tabview.vue?vue&type=script&lang=ts"
export * from "./base-tabview.vue?vue&type=script&lang=ts"

import "./base-tabview.vue?vue&type=style&index=0&id=be59c1f2&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__